import { TYPE } from '../tda/tda.js';

/**
 * String format utility class
 */
export var STR = {

  /**
   * Checks if a text is empty
   */
  isEmpty: function(str) {
    if (str === 0) {
      str = String(str); // To avoid problems when id is 0.
    }
    return (!str || 0 === str.length);
  },

  /**
   * Checks if a text is blank or null
   */
  isBlank: function(str) {
    if (str === 0 || typeof str === "boolean") {
      str = String(str); // To avoid problems when id is 0.
    }
    return (!str || /^\s*$/.test(str));
  },

  isNull: function(str) {
    return (str === null || str === "null" || (Array.isArray(str) && str.length === 0));
  },

  isUndefined: function(str) {
    return (str === undefined || str === "undefined");
  },

  /**
   * Replaces the parametres on the message with the parametres value.
   */
  buildMessageParametres: function(message, parametres) {
    var result = "";
    if (!STR.isBlank(message)) {
      result = message;
      if (!STR.isBlank(parametres)) {
        var array = [];
        for (var i in parametres) {
          if (i) {
            array.push(i);
          }
        }
        array.sort(function(a, b) {
          return b.length - a.length;
        });
        for (var j = 0; j < array.length; j++) {
          result = result.replace(array[j], parametres[array[j]]);
        }
      }
    }
    return result;
  },

  /**
   * Format an array of Messages by joining all of them and putting a back
   */
  formatMessage: function(msgs) {
    var strMsg = "";
    var self = this;

    // Valid for arrays ["msg1","msg2"] or objects {1:"msg1",2:"msg2"}, or
    // complex objects like {1:{2:"msg1"},2:"msg2"}
    _.each(msgs, function(value) {
      if (_.isObject(value)) {
        value = self.formatMessage(value);
        value = value.substring(2, value.length - 1);
      }
      strMsg = strMsg + "* " + value + "\n";
    });
    return strMsg;
  },

  /*
   Return formated value from a Caractéristique Paramétrable
    caracteristique: { code: "personum", tda: {...}, masque: "&&:&&", type: "N", valeur: 10, ... }
   */
  formatCarpersValue: function(caracteristique) {
    var result = "",
      tdaType = "";
    var value = caracteristique.valeur;
    var masque = caracteristique.masque; // Get masque

    switch (caracteristique.type) {
      case "C":
        break;
      case "N":
        tdaType = TYPE.LONG;
        break;
      case "D":
        tdaType = TYPE.DATE;
        break;
        /* no default */
    }
    // Overwrite tda type if selected
    if (!STR.isBlank(caracteristique.tda)) {
      tdaType = TYPE._getTypeByCode(caracteristique.tda)
    }
    // If no masque, take it from tdatype
    if (STR.isBlank(masque) && tdaType && tdaType.format) {
      masque = TYPE._getFormatByCode(caracteristique.tda);
    }
    // Format value if masque exists
    if (tdaType && tdaType.format) {
      result = tdaType.format(value, masque);
    } else {
      result = value;
    }
    if (!STR.isBlank(caracteristique.codif) && !STR.isBlank(caracteristique.valeur) && !STR.isBlank(caracteristique.codif.code)) {
      if (!STR.isBlank(caracteristique.valeurcodif.libelle)) {
        result = caracteristique.valeurcodif.libelle + " (" + caracteristique.valeurcodif.code + ")";
      } else {
        result = caracteristique.valeurcodif.code;
      }
    }
    return result;
  },

  /**
   * Get an el value from a model : getElValue(model, "regleCalcul.libelle")
   *
   */
  getElValue: function(model, property) {
    var tokens = property.split(".");
    var rootValue = (model === null || model === undefined) ? null : model.get(tokens[0]);
    var value = rootValue;

    for (var i = 1; i < tokens.length; i++) {
      if (value === null || value === undefined) {
        return null;
      }
      value = value[tokens[i]];
    }
    return value;
  },

  /**
   * Similar to getElValue but from a JSON object instead of a model.
   *
   */
  getElValueFromObj: function(object, property) {
    var tokens = property.split(".");

    if (!_.has(object, tokens[0])) {
      return null;
    }
    var rootValue = object[tokens[0]];
    var value = rootValue;
    for (var i = 1; i < tokens.length; i++) {
      if (value === null || value === undefined) {
        return null;
      }
      value = value[tokens[i]];
    }
    return value;
  },

  /**
   * Set an el value to a model : setElValue(model, "regleCalcul.code",
   * "REGUL")
   *
   */
  setElValue: function(model, property, value, options) {
    var tokens = property.split(".");
    var objectValue = {};

    if (tokens.length > 1) {
      // Complex element
      objectValue = _.clone(model.get(tokens[0]));
      if (objectValue === null || objectValue === undefined) {
        objectValue = {};
      }
      objectValue = this._extendObject(objectValue, tokens, 1, value);
    } else {
      // Simple element
      objectValue = value;
    }

    if (STR.isBlank(model)) {
      model = new Backbone.Model();
    }
    return model.set(tokens[0], objectValue, options);
  },

  /**
   * Replaces the char at the desired position for the string
   */
  replaceCharAt: function(str, index, chr) {
    if (index > str.length - 1) { return str; }
    return str.substr(0, index) + chr + str.substr(index + 1);
  },

  /**
   * Recursive method that insert a value in a complex object.
   */
  _extendObject: function(object, tokens, index, value) {
    if (String(tokens.length - 1) === String(index)) {
      object[tokens[index]] = value;
      return object;
    }
    if (!object[tokens[index]]) { object[tokens[index]] = {}; }
    _.extend(object[tokens[index]], this._extendObject(object[tokens[index]], tokens, index + 1, value));
    return object;
  },

  extractObjectValues: function(object) {
    var auxArray = _.values(object);
    var self = this;

    _.each(auxArray, function(it, index) {
      if (_.isObject(it)) {
        auxArray[index] = self.extractObjectValues(it);
      }
    });
    _.flatten(auxArray);
    return auxArray;
  },

  toFirstUpperCase: function(string) {
    return string.substring(0, 1).toUpperCase() + string.substring(1);
  },
  convertToAscii: function(string) {
    var i = 0;
    var resultString = "";

    if (!STR.isBlank(string)) {
      for (i = 0; i < string.length; i++) {
        resultString += "&#" + string.charCodeAt(i) + ";";
      }
    }
    return resultString;
  }
};
